<template>
<div class="modal fade" id="myModalConfirm" tabindex="-1" role="dialog" aria-labelledby="modalLabelConfirm" aria-hidden="true">
  <div class="modal-dialog modal-dialog-sm" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title" id="modalLabel">
          <strong>{{def.title}}</strong>
        </h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">
            &times;
          </span>
        </button>
      </div>
      <div class="modal-body text-left">
        <p v-html="def.msg"></p>
      </div>
      <div class="modal-footer">
        <button
          type="button" id="confirmCancel"
          class="btn btn-default btn-sm"
          data-dismiss="modal"
        >{{def.cancelText}}</button>
        <button type="button" id="confirm" class="btn btn-warning btn-sm"><i class="fa fa-check"></i> {{def.okText}}</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    def: {
      title: '',
      msg: '継続しますか？',
      cancelText: 'キャンセル',
      okText: '確定'
    }
  }
}
</script>
<style scoped>
.modal-header {
  padding:0.8em 1em 0.8em 1em;
  border-bottom: 1px solid #f8f8f8
}
.modal-footer {
  padding:0.6em;
  border-top: 1px solid #f8f8f8;
}
.btn-default {
  background: #f3f3f3
}
.modal {
  top: 20%;
}
</style>
